export const SUSER = 150;
export const DISTRIBUTOR = 175;
export const ADMIN = 200;
